<form name="form"
      autocomplete="off"
      (ngSubmit)="onFormSubmit(visitReviewForm)"
      #visitReviewForm="ngForm">
  <div class="mb-4">
    <div class="row mb-2">
      <div class="col-12 col-md-10 col-lg-9">
        <div class="d-flex flex-column flex-md-row">
          <span class="flex-fill pt-1"
                [translate]="'VISIT-REVIEWS.ADD.GRADE-SALON'">
          </span>
          <app-rating-stars [clickable]="true"
                            [(ratingValue)]="visitReviewFormData.salonRating"
                            [ratingStarsSize]="'lg'"></app-rating-stars>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-md-10 col-lg-9">
        <div class="d-flex flex-column flex-md-row">
          <span class="flex-fill pt-1"
                [translate]="'VISIT-REVIEWS.ADD.GRADE-EMPLOYEE'">
          </span>
          <app-rating-stars [clickable]="true"
                            [(ratingValue)]="visitReviewFormData.employeesRating"
                            [ratingStarsSize]="'lg'"></app-rating-stars>
        </div>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12 col-md-10 col-lg-9">
        <div class="d-flex flex-column flex-md-row">
          <span class="flex-fill pt-1"
                [translate]="'VISIT-REVIEWS.ADD.GRADE-TREATMENT'">
          </span>
          <app-rating-stars [clickable]="true"
                            [(ratingValue)]="visitReviewFormData.treatmentRating"
                            [ratingStarsSize]="'lg'"></app-rating-stars>
        </div>
      </div>
    </div>
  </div>

  <div class="form-check custom-control custom-checkbox mb-3">
    <input class="form-check-input custom-control-input"
           autocomplete="off"
           type="checkbox"
           value=""
           id="allowShowingCustomerName"
           name="allowShowingCustomerName"
           [(ngModel)]="visitReviewFormData.allowsShowingCustomerName">
    <label class="form-check-label custom-control-label"
           for="allowShowingCustomerName"
           [translate]="'VISIT-REVIEWS.ADD.CHECKBOX-ALLOW-CUSTOMER-NAME-DISPLAY'">
    </label>
  </div>

  <div class="form-group">
    <label [translate]="'VISIT-REVIEWS.ADD.INPUT-CUSTOMER-REVIEW.LABEL'"
           class="visually-hidden"></label>
    <textarea class="form-control"
              autocomplete="off"
              type="text"
              rows="4"
              trim
              id="customerReviewText"
              #customerReviewText="ngModel"
              name="customerReviewText"
              [(ngModel)]="visitReviewFormData.description"
              validate-onblur
              [maxlength]="customerReviewTextLimit"
              placeholder="{{'VISIT-REVIEWS.ADD.INPUT-CUSTOMER-REVIEW.PLACEHOLDER' | translate}}"></textarea>

    <div *ngIf="customerReviewText.invalid && (customerReviewText.dirty || customerReviewText.touched || visitReviewForm.submitted)"
         class="text-danger"
         [@inOutAnimation]>
    </div>

    <span class="text-secondary">
      {{customerReviewTextLimit - visitReviewFormData.description.length}} / {{customerReviewTextLimit}}
    </span>
  </div>

  <div *ngIf="!allGradesFilled && visitReviewForm.submitted"
       class="text-danger"
       [@inOutAnimation]
       [translate]="'VISIT-REVIEWS.ADD.ERROR-ALL-GRADES-REQUIRED'">
  </div>

  <div class="text-end">
    <button type="submit"
            class="btn btn-primary"
            [translate]="'VISIT-REVIEWS.ADD.BUTTON-SEND'">
    </button>
  </div>
</form>
